module.exports = __webpack_public_path__ + "static/media/physics.25ee1ed5.jpg";